module.exports = __webpack_public_path__ + "fefc5f65c7cafad7f48a3a6647fd9e15.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!../data/badlogicsmall.jpg
 ** module id = 19
 ** module chunks = 0
 **/